$(document).ready(function () {

    const container = document.querySelector(".scroll-container");

    // Arrow scroll
    $(".next").click(function () {
        container.scrollBy({ left: 400, behavior: "smooth" });
        setTimeout(updateButtons, 400);
    });

    $(".prev").click(function () {
        container.scrollBy({ left: -400, behavior: "smooth" });
        setTimeout(updateButtons, 400);
    });

    container.addEventListener("scroll", updateButtons);

    // Drag + Momentum
    let isDown = false;
    let startX;
    let scrollLeft;
    let velocity = 0;
    let raf;

    container.addEventListener("mousedown", (e) => {
        isDown = true;
        container.classList.add("dragging");

        startX = e.pageX;
        scrollLeft = container.scrollLeft;

        cancelAnimationFrame(raf);
    });

    container.addEventListener("mouseleave", () => {
        isDown = false;
        container.classList.remove("dragging");
    });

    container.addEventListener("mouseup", () => {
        isDown = false;
        container.classList.remove("dragging");
        applyMomentum();
    });

    container.addEventListener("mousemove", (e) => {
        if (!isDown) return;

        const x = e.pageX;
        const walk = (x - startX);

        container.scrollLeft = scrollLeft - walk;

        velocity = walk;
    });

    function applyMomentum() {
        velocity *= 0.95;

        container.scrollLeft -= velocity;

        if (Math.abs(velocity) > 0.5) {
            raf = requestAnimationFrame(applyMomentum);
        }
    }

    function updateButtons() {
        const scrollLeft = container.scrollLeft;
        const maxScroll = container.scrollWidth - container.clientWidth;

        // Disable prev if at start
        if (scrollLeft <= 0) {
            $(".prev").prop("disabled", true);
        } else {
            $(".prev").prop("disabled", false);
        }

        // Disable next if at end
        if (scrollLeft >= maxScroll - 1) {
            $(".next").prop("disabled", true);
        } else {
            $(".next").prop("disabled", false);
        }
    }

    updateButtons();
});


$(document).ready(function () {

    // Open first item by default
    $(".halo-faq-item.active .halo-faq-answer").css({
        "max-height": $(".halo-faq-item.active .halo-faq-answer")[0].scrollHeight + "px"
    });

    $(".halo-faq-question").click(function () {
        let parent = $(this).parent();

        if (parent.hasClass("active")) {
            // Close current
            parent.removeClass("active");
            parent.find(".halo-faq-answer").css("max-height", "0");
            parent.find(".halo-faq-icon").text("+");
        } else {

            // Close others
            $(".halo-faq-item").removeClass("active");
            $(".halo-faq-answer").css("max-height", "0");
            $(".halo-faq-icon").text("+");

            // Open current
            parent.addClass("active");
            let answer = parent.find(".halo-faq-answer");

            answer.css("max-height", answer[0].scrollHeight + "px");
            parent.find(".halo-faq-icon").text("−");
        }
    });

});


$(document).ready(function () {

    // OPEN
    $("#faqPopup").click(function () {

        let overlay = $(".halo-v2-faq-modal-overlay");

        overlay.css("display", "block");

        // small delay to allow DOM paint → enables transition
        setTimeout(() => {
            overlay.addClass("show");

            // initially evaluate height
            $(".halo-v2-faq-modal-item.active .halo-v2-faq-modal-answer").each(function () {
                $(this).css("max-height", this.scrollHeight + "px");
            });
        }, 10);

        $("body").css("overflow", "hidden");
    });

    // CLOSE FUNCTION
    function closeModal() {
        let overlay = $(".halo-v2-faq-modal-overlay");

        overlay.removeClass("show");

        // wait for animation to finish before hiding
        setTimeout(() => {
            overlay.css("display", "none");
        }, 400);

        $("body").css("overflow", "auto");
    }

    // Close events
    $(".halo-v2-faq-modal-close, .halo-v2-faq-modal-overlay").click(function (e) {
        if (e.target !== this && !$(e.target).hasClass("halo-v2-faq-modal-close")) return;
        closeModal();
    });

    $(".halo-v2-faq-modal").click(function (e) {
        e.stopPropagation();
    });

    // INIT first open
    $(".halo-v2-faq-modal-item.active .halo-v2-faq-modal-answer").each(function () {
        $(this).css("max-height", this.scrollHeight + "px");
    });

    // ACCORDION
    $(".halo-v2-faq-modal-question").click(function () {

        let parent = $(this).closest(".halo-v2-faq-modal-item");

        if (parent.hasClass("active")) {
            parent.removeClass("active");
            parent.find(".halo-v2-faq-modal-answer").css("max-height", "0");
            parent.find(".halo-v2-faq-modal-icon").text("+");
        } else {

            $(".halo-v2-faq-modal-item").removeClass("active");
            $(".halo-v2-faq-modal-answer").css("max-height", "0");
            $(".halo-v2-faq-modal-icon").text("+");

            parent.addClass("active");

            let answer = parent.find(".halo-v2-faq-modal-answer");
            answer.css("max-height", answer[0].scrollHeight + "px");

            parent.find(".halo-v2-faq-modal-icon").text("−");
        }
    });

});